import * as React from 'react';
import { Route, Routes } from '@leagueplatform/routing';
import { WalletLandingPage } from '#pages/wallet-landing/wallet-landing.page.tsx';
import { WalletDetail } from '#pages/wallet-detail/wallet-detail.component.tsx';
import { DeepLinkWrapper } from '#components/deep-link-wrapper/deep-link-wrapper.component.tsx';
import { useWalletMockData } from '#hooks/use-wallet-mock-data.hook.ts';

export const WalletRoutes = () => (
  <Routes>
    <Route index element={<WalletLandingPage />} />
    <Route
      path=":benefitId/:sectionId/*"
      element={
        <DeepLinkWrapper>
          <WalletDetail />
        </DeepLinkWrapper>
      }
    />
    <Route
      path=":benefitId/*"
      element={
        <DeepLinkWrapper>
          <WalletDetail />
        </DeepLinkWrapper>
      }
    />
  </Routes>
);

export function MockedWalletRoutes() {
  useWalletMockData();
  return <WalletRoutes />;
}
